import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      height: '100%',
      maxWidth: '100% !important',
      maxHeight: '100% !important',
      position: 'relative',
    },
    noPadding: {
      padding: 0,
    },
  }),
);
